import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NameDto } from 'api/Common/Types'
import {
  LuckyDrawActivityTypeDto,
  LuckyDrawRewardTypeDto,
} from 'api/Trading-Accounts/Types/MarketingCampaignResultsDto'
import { MarginBonusLabel } from 'api/Wallet/Types/BonusCampaignTypes'

export interface MarketingState {
  luckyDrawActivityTypes: LuckyDrawActivityTypeDto[]
  luckyDrawRewardTypes: LuckyDrawRewardTypeDto[]
  marginBonusWithdrawRules: NameDto[]
  marginBonusLabels: MarginBonusLabel[]
  marginBonusAvailabilityPeriods: NameDto[]
  marginBonusCountdownTriggers: NameDto[]
  marginBonusExcludeTypes: NameDto[]
}

const initialState: MarketingState = {
  luckyDrawActivityTypes: [],
  luckyDrawRewardTypes: [],
  marginBonusWithdrawRules: [],
  marginBonusLabels: [],
  marginBonusAvailabilityPeriods: [],
  marginBonusCountdownTriggers: [],
  marginBonusExcludeTypes: [],
}

export const marketingSlice = createSlice({
  name: 'marketing',
  initialState,
  reducers: {
    setLuckyDrawActivityTypesAction: (
      state: MarketingState,
      action: PayloadAction<LuckyDrawActivityTypeDto[]>
    ) => {
      state.luckyDrawActivityTypes = action.payload
    },
    setLuckyDrawRewardTypesAction: (
      state: MarketingState,
      action: PayloadAction<LuckyDrawRewardTypeDto[]>
    ) => {
      state.luckyDrawRewardTypes = action.payload
    },
    setMarginBonusWithdrawRulesAction: (
      state: MarketingState,
      action: PayloadAction<NameDto[]>
    ) => {
      state.marginBonusWithdrawRules = action.payload
    },
    setMarginBonusLabelsAction: (
      state: MarketingState,
      action: PayloadAction<MarginBonusLabel[]>
    ) => {
      state.marginBonusLabels = action.payload
    },
    setMarginBonusAvailabilityPeriodsAction: (
      state: MarketingState,
      action: PayloadAction<NameDto[]>
    ) => {
      state.marginBonusAvailabilityPeriods = action.payload
    },
    setMarginBonusCountdownTriggersAction: (
      state: MarketingState,
      action: PayloadAction<NameDto[]>
    ) => {
      state.marginBonusCountdownTriggers = action.payload
    },
    setMarginBonusExcludeTypesAction: (state: MarketingState, action: PayloadAction<NameDto[]>) => {
      state.marginBonusExcludeTypes = action.payload
    },
  },
})

export default marketingSlice
